import { render, staticRenderFns } from "./MobileHeaderUserMenu.vue?vue&type=template&id=fe3d639a&scoped=true&"
import script from "./MobileHeaderUserMenu.vue?vue&type=script&lang=js&"
export * from "./MobileHeaderUserMenu.vue?vue&type=script&lang=js&"
import style0 from "./MobileHeaderUserMenu.vue?vue&type=style&index=0&id=fe3d639a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3d639a",
  null
  
)

export default component.exports